// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.mediator[data-v-47cc3ec0]{width:100%}@media (min-width:768px){.mediator[data-v-47cc3ec0] .mediator-wrapper:first-child section{padding-top:3.2rem}}@media (max-width:1023px){.mediator[data-v-47cc3ec0] .mediator-wrapper:first-child section.hero-section{padding-top:0}}@media (max-width:767px){.mediator[data-v-47cc3ec0] .mediator-wrapper:first-child section{padding-top:2.4rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
